<template>
  <div>
    <v-layout class="align-center">
      <v-flex xs2>
        <AppForm label="絞り込み条件" />
      </v-flex>
      <v-flex xs1>
        <v-btn
          @click="onClickTargetCondition"
          :disabled="isPoiSubcategoryListEmpty"
          icon
          small
        >
          <v-icon>edit</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-btn v-if="loading" loading flat />
    <div v-else>
      <AppForm
        v-if="isPoiSubcategoryListEmpty"
        :titleWidth="10"
        label="このカテゴリーは絞り込み機能の対象外です。"
      />
      <AppForm v-else-if="isPoiSearchConditionsEmpty" label="指定なし" />
      <v-layout v-else wrap>
        <v-flex
          v-for="(condition, index) in poiSearchForm.conditions"
          :key="index"
          xs12
          mt-4
        >
          <!-- 各絞り込み条件 -->
          <POISearchCondition
            :categoryId="poiSearchForm.categoryId"
            :condition="condition"
            :subCategoryName="findSubCategoryName(condition.poiSubCategoryId)"
            @removeSubcategory="removeSubcategory"
          />
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import POISearchCondition from './POISearchCondition'

export default {
  name: 'POISearchConditions',
  components: {
    POISearchCondition,
  },
  props: {
    poiSearchForm: {
      type: Object,
      default: () => {},
    },
    poiSubcategoryList: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    isPoiSearchConditionsEmpty() {
      if (this.poiSearchForm.conditions.length === 0) return true
      return (
        this.poiSearchForm.conditions.length === 1 &&
        this.poiSearchForm.conditions[0].poiSubCategoryId === null
      )
    },
    isPoiSubcategoryListEmpty() {
      return this.poiSubcategoryList.length === 0
    },
  },
  methods: {
    findSubCategoryName(poiSubcategoryId) {
      if (poiSubcategoryId === null) return ''
      const matchingPoiSubCategory = this.poiSubcategoryList.find(
        subCategory => poiSubcategoryId === subCategory.id,
      )
      if (matchingPoiSubCategory === undefined) return ''
      return matchingPoiSubCategory.name
    },
    async removeSubcategory(subcategoryId) {
      this.poiSearchForm.removeSubcategory(subcategoryId)
    },
    onClickTargetCondition() {
      this.$emit('onClickTargetCondition')
    },
  },
}
</script>
